import React, {useState} from "react";
import {LoanDetailsCaption} from "../../../loan-details-caption/component/LoanDetailsCaption";
import {LoanData} from "../../model/LoanData";
import {LoanDetailsTableFirstName} from "./LoanDetailsTableFirstName";
import {LoanDetailsTableLastName} from "./LoanDetailsTableLastName";
import {LoanDetailsTableLoanNumber} from "./LoanDetailsTableLoanNumber";
import {LoanDetailsTableLoanAmount} from "./LoanDetailsTableLoanAmount";
import {LoanDetailsTableFee} from "./LoanDetailsTableFee";
import {LoanDetailsTableProperty} from "./LoanDetailsTableProperty";
import {LoanDetailsTablePaymentDue} from "./LoanDetailsTablePaymentDue";
import {LoanDetailsTableLoanOfficer} from "./LoanDetailsTableLoanOfficer";
import {SubmitButton} from "../../../../input/component/submit_button/SubmitButton";
import {LoanDetailsTableBody} from "./loadn-details-table-body/LoanDetailsTableBody";
import {LoanDetailsTablePaymentAmount} from "./LoanDetailsTablePaymentAmount";
import {FeeOptionKey, FeeSelector} from "../FeeSelector";
import {LoanType} from "../../model/LoanType";
import {CreditReportTableFee} from "./CreditReportTableFee";

interface Props {
    loan: LoanData;
    proceedToPayment: () => any;
    creditCartProceedToPayment: (selectedFees?: FeeOptionKey[]) => void
}

export function LoanDetailsTable({loan, proceedToPayment, creditCartProceedToPayment}: Props) {
    const [selectedFees, setSelectedFees] = useState<FeeOptionKey[]>([]);
    const [touched, setTouched] = useState(false);

    const toggleFee = (key: FeeOptionKey) => {
        setSelectedFees((prev) => {
            const selected = prev.includes(key)
                ? prev.filter((k) => k !== key)
                : [...prev, key];
            setTouched(true);
            return selected;
        });
    };

    const hasSelection = selectedFees.length > 0;

    const shouldShowFeeSelector = loan.appraisalFeeEnabled && loan.creditFeeEnabled;



    return (
        <>
            <LoanDetailsTableBody>
                <LoanDetailsTableFirstName firstName={loan.borrower.firstName}/>
                <LoanDetailsTableLastName lastName={loan.borrower.lastName}/>
                <LoanDetailsTableLoanNumber loanNumber={loan.loanNumber}/>
                <LoanDetailsTableLoanAmount loanAmount={loan.loanAmount}/>
                <LoanDetailsTableFee fee={loan.appraisalFeeEnabled ? loan.appraisalFee : ''}/>
                <CreditReportTableFee fee={loan.creditFeeEnabled ? loan.creditReportFee : ''}/>
                <LoanDetailsTablePaymentAmount paymentAmount={loan.paymentAmount}/>
                <LoanDetailsTablePaymentDue paymentDue={loan.paymentDue}/>
                <LoanDetailsTableLoanOfficer loanOfficer={loan.loanOfficer}/>
                <LoanDetailsTableProperty property={loan.property}/>
            </LoanDetailsTableBody>
            {loan.type === LoanType.CREDIT_CARD_LOAN && shouldShowFeeSelector && (
                <>
                    <FeeSelector
                        appraisalFeeEnabled={loan.appraisalFeeEnabled}
                        creditReportFeeEnabled={loan.creditFeeEnabled}
                        selectedFees={selectedFees}
                        toggleFee={toggleFee}
                        loanData={{
                            appraisalFee: loan.appraisalFee,
                            creditReportFee: loan.creditReportFee
                        }}
                    />

                    {!hasSelection && touched && (
                        <div role="alert" style={{color: "#B00020", margin: "4px 0 12px"}}>
                            Please select at least one fee.
                        </div>
                    )}
                </>
            )}
            {loan.type == LoanType.ACH_LOAN ?
                (<SubmitButton onClick={proceedToPayment}>
                    Confirm and Go To Payment
                </SubmitButton>) : (
                    (<SubmitButton
                            onClick={() => creditCartProceedToPayment(shouldShowFeeSelector ? selectedFees : undefined)}
                            disabled={shouldShowFeeSelector ? !hasSelection : false}>
                            Confirm and Go To Payment
                        </SubmitButton>
                    ))}


            <LoanDetailsCaption support={loan.support} type={loan.type}/>
        </>
    );
}
